export default "__VITE_ASSET__BBrcAD7s__"